// extracted by mini-css-extract-plugin
export default {"attachmentsPreview":"styles_attachmentsPreview__-6WIk","attachmentOuter":"styles_attachmentOuter__o3Bwo"};